// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'endpoints'"
        editRoute="endpointEdit"
        :filter="filters"
        :headers="headers"
        id="_id"
        name="Endpoint"
        permissions="endpoints"
        :searchBarText="searchBarText"
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {ENDPOINT} from '@/shared/constants'
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'UUID',
          value: 'uuid',
          sortable: true
        },
        {
          text: 'Coordinates',
          value: 'xycoordinates',
          sortable: true
        },
        {
          text: 'Auto Enroll',
          value: 'autoEnroll.enabled',
          type: 'checkbox',
          sortable: true
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'filters'
    ])
  },

  methods: {
    getSiteName: function (item, sites) {
      if (sites) {
        var site = sites.find((el) => el._id === item.site)
        if (site) {
          return site.name
        }
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Endpoints.vue